import { createRouter, createWebHashHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import constants from "@/api/constants";
import NotFound from "@/views/NotFound";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomePage,
    redirect: constants.navData[0].path,
    children: [
      {
        path: constants.navData[0].path,
        name: constants.navData[0].name,
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/MainPage.vue"),
        meta: { pageName: constants.navData[0].pageName },
      },
      {
        path: constants.navData[1].path,
        name: constants.navData[1].name,
        // component: () => import("../views/ProductPage.vue"),
        redirect: constants.navSubData[0].path,
        meta: { pageName: constants.navData[1].pageName },
        children: [
          {
            path: constants.navSubData[0].path,
            name: constants.navSubData[0].name,
            component: () => import("../views/SystemTechManagePage.vue"),
            meta: { pageName: constants.navSubData[0].pageName },
          },
          {
            path: constants.navSubData[1].path,
            name: constants.navSubData[1].name,
            component: () => import("../views/SystemHarmfulAlarmPage.vue"),
            meta: { pageName: constants.navSubData[1].pageName },
          },
          {
            path: constants.navSubData[2].path,
            name: constants.navSubData[2].name,
            component: () => import("../views/SystemDbPage.vue"),
            meta: { pageName: constants.navSubData[2].pageName },
          },
          {
            path: constants.navSubData[3].path,
            name: constants.navSubData[3].name,
            component: () => import("../views/SystemProductWatchPage.vue"),
            meta: { pageName: constants.navSubData[3].pageName },
          },
        ]
      },
      {
        path: constants.navData[2].path,
        name: constants.navData[2].name,
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/NewsPage.vue"),
        meta: { pageName: constants.navData[2].pageName },
        children: [
          {
            path: "/news/:id",
            name:"NewsDetailPage",
            component: () => import("../views/NewsDetailPage.vue"),
          }
          ,{
            path: "",
            component: () => import("../views/NewsItemsPage"),
          },

        ]
      },
    ],
  },
  { path: "/:pathMatch(.*)*", name: "NotFound", component: NotFound },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});
router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
